import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import WhyNotChatGPT from '../components/landing/WhyNotChatGPT';
import Features from '../components/landing/Features';
import Followups from '../components/landing/Followups';
import SectionTwoCards from '../components/landing/SectionTwoCards';
import WhyTelegram from '../components/landing/WhyTelegram';
import Community from '../components/landing/Community';
import HowItWorks from '../components/landing/HowItWorks';
import PricingCTA from '../components/landing/PricingCTA';
import FAQ from '../components/landing/FAQ';
import Privacy from '../components/landing/Privacy';
import Footer from '../components/landing/Footer';
import { useLanguage } from '../i18n/LanguageContext';

export default function Landing() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-ev-cream">
      <Navbar />
      <Hero />
      {/* Comparison strip — punchy "this isn't chatgpt" */}
      <WhyNotChatGPT />
      {/* Lime 3-col feature headline */}
      <Features />
      {/* Killer feature — proactive follow-ups with chat mockup (dark) */}
      <Followups />
      {/* Brief explainer — why Telegram, not WhatsApp (cream callout) */}
      <WhyTelegram />
      {/* Memory that feels — emotional + people memory (sage = brighter break) */}
      <SectionTwoCards
        id="memory"
        testId="memory-section"
        theme="sage"
        label={t.mp_label}
        h={t.mp_h}
        sub={t.mp_sub}
        items={t.mp_items}
      />
      {/* Adaptive voice (dark) */}
      <SectionTwoCards
        id="voice"
        testId="voice-section"
        theme="ink"
        label={t.pc_label}
        h={t.pc_h}
        sub={t.pc_sub}
        items={t.pc_items}
      />
      {/* Sunday reflection + caring morning briefs (butter) */}
      <SectionTwoCards
        id="proactive"
        testId="proactive-section"
        theme="butter"
        label={t.pa_label}
        h={t.pa_h}
        sub={t.pa_sub}
        items={t.pa_items}
      />
      {/* Independent by design — own tools (dark) */}
      <SectionTwoCards
        id="tools"
        testId="tools-section"
        theme="ink"
        label={t.tl_label}
        h={t.tl_h}
        sub={t.tl_sub}
        items={t.tl_items}
      />
      <Community />
      <HowItWorks />
      <Privacy />
      <PricingCTA />
      <FAQ />
      <Footer />
    </div>
  );
}
